import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, of, switchMap } from 'rxjs';

import { AvisoRpa } from 'src/app/core/models/credencial-rpa/CredencialRpa';
import { TipoUsuario } from 'src/app/core/enum/TipoUsuario';
import { AuthService } from 'src/app/core/services/auth';
import { CredencialRpaService } from 'src/app/core/services/credencial-rpa/credencial-rpa.service';

/**
 * Faixa de aviso de RPA parado, em todas as telas.
 *
 * Aparece só para quem está com a empresa DONA do RPA selecionada — por isso
 * assina `empresaSelecionada$` e refaz a busca a cada troca. Quem seleciona
 * outra empresa não vê nada, porque o backend devolve lista vazia.
 *
 * Duas decisões que valem explicar:
 *
 * 1. Quando o estado é CONTRATO_MUDOU, a faixa NÃO oferece o caminho para a
 *    tela de credenciais. Trocar a senha de um portal que mudou de rota é
 *    mandar a pessoa mexer justo no que está certo.
 *
 * 2. O link para a tela só aparece para IziiAdmin. A rota é protegida por
 *    RoleGuard; oferecer o link a quem vai bater em "sem permissão" é pior do
 *    que não oferecer.
 */
@Component({
  selector: 'app-aviso-rpa',
  templateUrl: './aviso-rpa.component.html',
  styleUrls: ['./aviso-rpa.component.scss'],
})
export class AvisoRpaComponent implements OnInit {
  private readonly credencialRpaService = inject(CredencialRpaService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  avisos: AvisoRpa[] = [];
  podeAbrirATela = false;
  /** Fechada por padrao: a faixa aparece em TODAS as telas, entao o detalhe inteiro
   *  empurrava o conteudo para baixo (4 avisos = meia tela). Uma linha basta para avisar. */
  detalhesAbertos = false;

  /** A tela de logins ja lista os mesmos problemas; a faixa ali so repetiria. */
  get naTelaDeLogins(): boolean {
    return this.router.url.startsWith('/credenciais-rpa');
  }

  get resumo(): string {
    return this.avisos.map((a) => a.rotulo).join(', ');
  }

  ngOnInit(): void {
    this.authService.empresaSelecionada$
      .pipe(
        switchMap((empresa) =>
          empresa
            ? this.credencialRpaService.getAvisos().pipe(
                // Falha aqui não pode quebrar a tela em que a pessoa está: a
                // faixa é um acessório de toda página, não a página.
                catchError(() => of([] as AvisoRpa[]))
              )
            : of([] as AvisoRpa[])
        )
      )
      .subscribe((avisos) => (this.avisos = avisos));

    this.authService.tipoUsuario$.subscribe(
      (tipo) => (this.podeAbrirATela = tipo === TipoUsuario.IziiAdmin)
    );
  }

  abrirTelaDeLogins(): void {
    this.router.navigate(['/credenciais-rpa']);
  }
}
